import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/auth/callback": [8],
		"/connect/[workspaceId]": [9],
		"/invite/[token]": [10],
		"/login": [11],
		"/media/[...key]": [12],
		"/oauth/consent": [13],
		"/onboarding": [14],
		"/pair": [15],
		"/settings/devices": [16],
		"/superadmin": [17,[2]],
		"/superadmin/admins": [18,[2]],
		"/superadmin/audit": [19,[2]],
		"/superadmin/audit/deleted-items": [20,[2]],
		"/superadmin/emails": [21,[2]],
		"/superadmin/orgs": [22,[2]],
		"/superadmin/orgs/[id]": [23,[2]],
		"/superadmin/users": [24,[2]],
		"/superadmin/users/[id]": [25,[2]],
		"/welcome/app": [26],
		"/welcome/asana": [27],
		"/welcome/clickup": [28],
		"/welcome/download": [29],
		"/welcome/github": [30],
		"/welcome/jira": [31],
		"/welcome/linear": [32],
		"/welcome/slack": [33],
		"/welcome/teams": [34],
		"/workspace": [35],
		"/workspace/[id]": [36,[3]],
		"/workspace/[id]/activity": [37,[3]],
		"/workspace/[id]/agents": [41,[3]],
		"/workspace/[id]/agent/new": [40,[3]],
		"/workspace/[id]/agent/[agentId]": [38,[3]],
		"/workspace/[id]/agent/[agentId]/subagent/[subagentId]": [39,[3]],
		"/workspace/[id]/audit/session/[agentId]": [42,[3]],
		"/workspace/[id]/browser/[sessionId]": [43,[3]],
		"/workspace/[id]/channel": [44,[3]],
		"/workspace/[id]/channel/[channelId]": [45,[3]],
		"/workspace/[id]/channel/[channelId]/details": [46,[3]],
		"/workspace/[id]/chats": [47,[3]],
		"/workspace/[id]/cybos/[cyboId]": [49,[3]],
		"/workspace/[id]/cybo/[cyboId]": [48,[3]],
		"/workspace/[id]/daemons": [50,[3]],
		"/workspace/[id]/daemons/[daemonId]": [51,[3]],
		"/workspace/[id]/dms": [53,[3]],
		"/workspace/[id]/dm/[userId]": [52,[3]],
		"/workspace/[id]/home": [54,[3]],
		"/workspace/[id]/logs": [55,[3]],
		"/workspace/[id]/member/[userId]": [56,[3]],
		"/workspace/[id]/memory": [57,[3]],
		"/workspace/[id]/people": [58,[3]],
		"/workspace/[id]/providers": [59,[3]],
		"/workspace/[id]/providers/[daemonId]/[accountKey]": [60,[3]],
		"/workspace/[id]/saved": [61,[3]],
		"/workspace/[id]/sessions": [63,[3]],
		"/workspace/[id]/session/[sessionId]": [62,[3]],
		"/workspace/[id]/settings": [64,[3,4]],
		"/workspace/[id]/settings/about": [65,[3,4]],
		"/workspace/[id]/settings/ai": [66,[3,4]],
		"/workspace/[id]/settings/appearance": [67,[3,4]],
		"/workspace/[id]/settings/autonomy": [68,[3,4]],
		"/workspace/[id]/settings/backend": [69,[3,4]],
		"/workspace/[id]/settings/billing": [70,[3,4]],
		"/workspace/[id]/settings/browser": [71,[3,4]],
		"/workspace/[id]/settings/connections": [72,[3,4]],
		"/workspace/[id]/settings/daemon": [73,[3,4]],
		"/workspace/[id]/settings/developer": [74,[3,4]],
		"/workspace/[id]/settings/devices": [75,[3,4]],
		"/workspace/[id]/settings/integrations": [76,[3,4]],
		"/workspace/[id]/settings/integrations/asana": [77,[3,4]],
		"/workspace/[id]/settings/integrations/clickup": [78,[3,4]],
		"/workspace/[id]/settings/integrations/everhour": [79,[3,4]],
		"/workspace/[id]/settings/integrations/github": [80,[3,4]],
		"/workspace/[id]/settings/integrations/jira": [81,[3,4]],
		"/workspace/[id]/settings/integrations/linear": [82,[3,4]],
		"/workspace/[id]/settings/integrations/recipes/[recipeId]": [83,[3,4]],
		"/workspace/[id]/settings/integrations/slack": [84,[3,4]],
		"/workspace/[id]/settings/integrations/teams": [85,[3,4]],
		"/workspace/[id]/settings/logs": [86,[3,4]],
		"/workspace/[id]/settings/mcp": [87,[3,4]],
		"/workspace/[id]/settings/members": [88,[3,4]],
		"/workspace/[id]/settings/notifications": [89,[3,4]],
		"/workspace/[id]/settings/profile": [90,[3,4]],
		"/workspace/[id]/settings/provider-usage": [91,[3,4]],
		"/workspace/[id]/settings/provider-usage/[daemonId]/[accountKey]": [92,[3,4]],
		"/workspace/[id]/settings/providers": [93,[3,4]],
		"/workspace/[id]/settings/security": [94,[3,4]],
		"/workspace/[id]/settings/slack-sync": [95,[3,4]],
		"/workspace/[id]/settings/teams-sync": [96,[3,4]],
		"/workspace/[id]/settings/webhooks": [97,[3,4]],
		"/workspace/[id]/settings/webhooks/activity": [99,[3,4]],
		"/workspace/[id]/settings/webhooks/outgoing": [100,[3,4]],
		"/workspace/[id]/settings/webhooks/rule": [101,[3,4]],
		"/workspace/[id]/settings/webhooks/[channelId]/[webhookId]": [98,[3,4]],
		"/workspace/[id]/settings/workspace": [102,[3,4]],
		"/workspace/[id]/skills": [103,[3]],
		"/workspace/[id]/tasks": [104,[3,5]],
		"/workspace/[id]/tasks/item/[taskId]": [114,[3,5]],
		"/workspace/[id]/tasks/[projectId]/analytics": [105,[3,5]],
		"/workspace/[id]/tasks/[projectId]/cycles": [106,[3,5]],
		"/workspace/[id]/tasks/[projectId]/cycles/[cycleId]": [107,[3,5]],
		"/workspace/[id]/tasks/[projectId]/modules": [108,[3,5]],
		"/workspace/[id]/tasks/[projectId]/modules/[moduleId]": [109,[3,5]],
		"/workspace/[id]/tasks/[projectId]/overview": [110,[3,5]],
		"/workspace/[id]/tasks/[projectId]/pages": [111,[3,5,6]],
		"/workspace/[id]/tasks/[projectId]/pages/[pageId]": [112,[3,5,6]],
		"/workspace/[id]/tasks/[projectId]/work-items": [113,[3,5]],
		"/workspace/[id]/terminal/[terminalId]": [115,[3]],
		"/workspace/[id]/threads": [116,[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';